(function () {
    'use strict';

    angular.module("imApp").factory("timeStampStartCorrService", ['$ihttp', function ($ihttp) {
        let service = {
            getTimeStampStartCorr: function (parms) {
                return $ihttp.post({
                    method: 2587,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2588,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
